import { render, staticRenderFns } from "./PostCreatePage.vue?vue&type=template&id=0aa89351&"
import script from "./PostCreatePage.vue?vue&type=script&lang=js&"
export * from "./PostCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./PostCreatePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
